import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const alphaVantage = defineConnector({
  identifier: "alphaVantage",
  name: "Alpha Vantage",
  tagLine: "Stock and financial market data",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://www\\.alphavantage\\.co/.*",
  auth: (app) => queryAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get a free API key",
      items: [
        {
          kind: "markdown",
          content:
            "Request a key at [alphavantage.co/support](https://www.alphavantage.co/support/#api-key) — it’s issued instantly.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://www.alphavantage.co/query?function=GLOBAL_QUOTE&symbol=IBM",
      expectedBodyContains: "Global Quote",
    }),
  },
});
